import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UrlService} from '../../../core/services/url.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {AsideService} from '../../../core/services/aside.service';
import {TilesService} from '../../../core/services/tiles.service';
import {AppsService} from '../../../core/services/apps.service';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-alarms',
  templateUrl: './alarms.component.html',
  styleUrls: ['./alarms.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class AlarmsComponent implements OnInit {

  constructor(
    private store: Store<AppState>,
    private asideService: AsideService,
    private tilesService: TilesService,
    private appsService: AppsService,
  ) {
  }


  ngOnInit(): void {
    this.tilesService.fetchUserTiles$().subscribe();
    this.appsService.fetchUserApps$().subscribe();

    this.updateAside();
  }


  private updateAside() {
    this.asideService.replaceContextSections([
      {
        name: 'Alarms',
        items: [
          {
            text: 'Current',
            path: UrlService.makeAlarmsDashboardUrl(),
          },
          {
            text: 'History',
            path: UrlService.makeAlarmsHistoryUrl(),
          },
        ],
      },
    ]);
  }
}
